import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({ confirm, onClose }) => (
  <AlertDialog open={!!confirm} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent className="border-line bg-surface2 text-white" data-testid="confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>{confirm?.title}</AlertDialogTitle>
        <AlertDialogDescription className="text-txt2">{confirm?.text}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="border-lineStrong bg-transparent text-white hover:bg-surface3 hover:text-white" data-testid="confirm-cancel">Otkaži</AlertDialogCancel>
        <AlertDialogAction className="bg-brand text-white hover:bg-red-600" onClick={() => confirm?.onOk()} data-testid="confirm-ok">{confirm?.ok || "Potvrdi"}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
